<template>
  <div class="labeled-text">
    <div class="d-flex align-center">
      <v-icon v-if="icon" v-show="icon">{{ icon }}</v-icon>
      <div class="icon-container"><slot name="icon" /></div>
      <div class="content">
        <div class="d-flex">
          <div class="label" :class="{ clickable }" @click="handleClick">
            {{ label }}
          </div>
          <div class="sublabel ml-1" v-if="subLabel">{{ subLabel }}</div>
        </div>
        <div v-if="hasContent"><slot /></div>
        <div v-else>-</div>
      </div>
    </div>
    <div class="action"><slot name="action" /></div>
  </div>
</template>

<script>
export default {
  name: "LabeledText",
  props: {
    label: String,
    subLabel: String,
    icon: String,
    bold: {
      type: Boolean,
      default: true
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasContent() {
      return !!this.$slots.default;
    }
  },
  methods: {
    handleClick(event) {
      if (this.clickable) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.labeled-text {
  justify-content: space-between;
  flex-wrap: wrap;

  @media only screen and (max-width: $mobile-breakpoint - 1) {
    .action {
      max-width: 100%;
    }
  }

  .sublabel {
    color: $secondary-text;
    font-weight: 600;
    position: unset;
  }

  .clickable {
    color: $primary !important;
  }
}
</style>
